module.exports = __webpack_public_path__ + "static/media/slider1img.454a2baf.jpg";